import axios from "axios";
import { AXIOS } from "../customAxios";

export async function login(formData: FormData, clientId: string) {
  const data = await axios.post(`/auth/login`, formData, {
    headers: {
      clientId
    }
  });

  return data;
}

export async function forgotPassword({ userName, clientId }: { userName: string, clientId: string }) {
  const data = await axios.post(`/auth/forgotPassword`, { userName }, {
    headers: {
      clientId,
      "Content-Type": "application/json"
    }
  });

  return data;
}

export async function validateToken({ email: userEmail, token, clientId }: { email: string, token: string, clientId: string }) {
  const data = await axios.post(`/auth/validateToken`, { token, userEmail }, {
    headers: {
      clientId,
      "Content-Type": "application/json"
    }
  });

  return data;
}

export async function resetPassword({
  confirmPassword,
  newPassword,
  token,
  userName,
  clientId
}: {
  confirmPassword: string,
  newPassword: string,
  token: string,
  userName: string,
  clientId: string
}) {
  const data = await axios.post(`/auth/resetPassword`, {
    confirmPassword,
    newPassword,
    token,
    userName
  }, {
    headers: {
      clientId,
      "Content-Type": "application/json"
    }
  });

  return data;
}

export async function verifyOtp({ clientId, ...restData }: {
  token: string, verificationCode: string, password: string,
  username: string, clientId: string
}) {
  const data = await axios.post(`/auth/verifyVCode`, restData, {
    headers: {
      clientId
    }
  })
  return data;
}

export async function resendOtp({ token, clientId }: { token: string, clientId: string }) {
  const data = await axios.post(`/auth/resendVCode`, token, {
    headers: {
      clientId,
      "Content-Type": "application/json"
    }
  })
  return data;
}

export async function getClientLoginPageDetails(token: string) {
  const data = await axios.get(`/auth/fetchClientLoginPageDetails`, {
    params: {
      token
    }
  })
  return data;
}

export async function fetchLoginSuccess() {
  const data = await AXIOS.post(`/api/master/fetchSuccessLoginResponse`)
  return data;
}
